<template lang="pug">
  v-text-field(
    :value="value",
    :rules="required ? [v => !!v || this.$attrs.label + ' is required'] : []",
    v-bind="$attrs",
    @keydown.stop="update",
    @input="$emit('update:value', $event)",
  )
</template>

<script>
import { keyCodeIsNumeric } from '@/utils/helper';

export default {
  props: {
    value: {
      validator: prop =>
        ['string', 'number', 'object', 'undefined'].includes(typeof prop),
      required: true,
    },

    required: {
      type: Boolean,
      default: true,
    },

    onlyNumber: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    update(e) {
      const key = e.charCode || e.keyCode || 0;

      if (key === 13) {
        event.preventDefault();
        this.$emit('enter');
      }

      if (this.onlyNumber && !keyCodeIsNumeric(key)) {
        event.preventDefault();
      }
    },
  },
};
</script>
